module.exports = __webpack_public_path__ + "static/images/ee3cd366d6cfbd6c6f2c3c26bde79344.png";